import {HttpTransportType, HubConnection, HubConnectionBuilder} from "@microsoft/signalr";
import { useEffect, useState } from "react";

export class TerminalBilgiResponse
{
    constructor(){
        this.message = "İşlem Başarılı"
        this.success = true
    }
    success : boolean;
    message : string;
    printers: Array<string>;
    ipAdres : Array<string>;
    terminalAdi: string;
    macAdres : string;
}


class BarkodDetail {
    barkodNo : string;
    aciklama1: string;
    aciklama2: string;
    aciklama3: string;
    aciklama4: string;
    aciklama5: string;
    aciklama6: string;
    aciklama7: string;
    aciklama8: string;
    aciklama9: string;
    aciklama10: string;
    barkodType: BarkodType.Code128;
}
export enum BarkodType  {
    "Code128","Code39","I2Of5"
}
export class BarcodeInfo {
    XmlSablon? : string;
    SorguSablon? : string
    PrinterName? : string;
}

export class ReportInfo {
    XmlSablon? : string;
    PrinterName? : string;
}

export class EImzaLoginDTO
{
    eImzaKimlikId: string
    basarili: boolean
    mesaj: string
}

export class OrigoImzaModel
{
    BaseUrl: string //192.168.1.12:1111/Api gibi
    PinKodu: string
    UserName: string //èToken almak için kullanıcı username
    Password: string  //èToken almak için kullanıcı pass
}

export class SignalRService {
    
    public hubConn = new HubConnectionBuilder().withUrl("http://localhost:5000/HubKanal", {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
    }).build()

    isConncect = (): string =>{
        return this.hubConn.connectionId;
    }

    connect = async (): Promise<any> => {
        await this.hubConn.start();
    }

    disConnect = async (): Promise<any> => {
        await this.hubConn.stop();
    }

    getTerimnalBilgi= async () : Promise<TerminalBilgiResponse | any> => {
        try {
            if(this.hubConn.start){
                await this.hubConn.invoke("GetTerminalBilgi")
            }
        }
        catch (error) {
            return error;
        }
    }

    getTerimnalBilgiResponse= () : TerminalBilgiResponse => {
        try {
            if(this.hubConn.start){
                    this.hubConn.on("GetTerminalBilgiResponse",(response:TerminalBilgiResponse) => {  
                    this.disConnect()               
                    return <TerminalBilgiResponse>response;
                })
            }
        }
        catch (error) {
            return error;
        }
    }

    barcodePrint = async (barkodInfo : BarcodeInfo) : Promise<any> => { 
        try {
            if(this.hubConn){
                await this.hubConn.invoke("BarkodYazdir",barkodInfo).then((res)=>{})
            }
        } catch (error) {
            return error
        }
    }

    reportPrint = async (reportInfo : ReportInfo) : Promise<any> => { 
        try {
            if(this.hubConn){
                await this.hubConn.invoke("RaporYazdir",reportInfo).then((res)=>{})
            }
        } catch (error) {
            return error
        }
    }

    eimzaLoginKontrol = async (pinKodu : string) : Promise<any> => { 
        try {
            if(this.hubConn){
                await this.hubConn.invoke("EImzaLoginKontrol",pinKodu).then((res)=>{})
            }
        } catch (error) {
            return error
        }
    }

    eImzaLoginKontrolResponse = () : EImzaLoginDTO => {
        try {
            if(this.hubConn.start){
                    this.hubConn.on("EImzaLoginKontrolResponse",(response:EImzaLoginDTO) => {  
                    this.disConnect()               
                    return <EImzaLoginDTO>response;
                })
            }
        }
        catch (error) {
            return error;
        }
    }

    origoTopluRaporEImzaIslemleri = async (eimzaModel : OrigoImzaModel) : Promise<any> => { 
        try {
            if(this.hubConn){
                await this.hubConn.invoke("OrigoTopluRaporEImzaIslemleri",eimzaModel).then((res)=>{})
            }
        } catch (error) {
            return error
        }
    }

    origoTopluRaporEImzaIslemleriResponse = () : EImzaLoginDTO => {
        try {
            if(this.hubConn.start){
                    this.hubConn.on("OrigoTopluRaporEImzaIslemleriResponse",(response:EImzaLoginDTO) => {  
                    this.disConnect()               
                    return <EImzaLoginDTO>response;
                })
            }
        }
        catch (error) {
            return error;
        }
    }
 }
